var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Iconly/Bulk/Show",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 33",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 1",
    d: "M16.5 27.5h-.014c-5.677 0-10.782-3.968-13.655-10.614a1 1 0 010-.786C5.7 9.463 10.805 5.5 16.487 5.5h.014a12.8 12.8 0 017.888 2.813A19.567 19.567 0 0130.17 16.1a1 1 0 010 .786C27.296 23.532 22.186 27.5 16.5 27.5zm0-16.334a5.327 5.327 0 105.35 5.334 5.356 5.356 0 00-5.35-5.333z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Fill 4",
    d: "M19.843 16.495a3.347 3.347 0 01-6.694 0 3.467 3.467 0 01.067-.652h.067a2.746 2.746 0 002.75-2.641 2.81 2.81 0 01.47-.04 3.342 3.342 0 013.34 3.333"
  })));
}

export default SvgEye;